import React from 'react';
import Paper from "@material-ui/core/Paper/Paper";
import List from "@material-ui/core/List/List";
import ListItem from "@material-ui/core/ListItem/ListItem";
import i18n from "../../i18n";
import {withStyles} from "@material-ui/core";
import Grid from "@material-ui/core/Grid/Grid";
import {FormattedNumber} from "react-intl";
import Typography from "@material-ui/core/Typography/Typography";
import Divider from "@material-ui/core/Divider/Divider";
import Icon from "@material-ui/core/Icon/Icon";
import Button from "@material-ui/core/Button/Button";
import EllipisWithTooltip from "../Formater/EllipsisWithTooltip";
import FormaterDate from "../Formater/Date";


const renderDetailsRow = (label, value, classes) => {
    return (
        <ListItem key={Math.random()} dense className={classes.detailsRow}>
            <Grid container spacing={24}>
                <Grid item xs={4}>
                    <Typography className={classes.detailsLabel} component={"div"}
                                variant={"subtitle2"}>{(<EllipisWithTooltip>{label}</EllipisWithTooltip>)}</Typography>
                </Grid>
                <Grid item xs={8}>
                    <Typography className={classes.detailsValue} component={"div"}
                                variant={"body2"}>{value}</Typography>
                </Grid>
            </Grid>
        </ListItem>
    );
};

class InvoiceDetails extends React.Component {
    render() {
        const {invoice, classes, short} = this.props;
        return invoice && (
            <Paper className={classes.spaces}>
                <Typography component={"h6"} variant={"h6"}>
                    {i18n.get('invoice.title.show', invoice)}
                </Typography>
                <div className={classes.details}>
                    {short && (<Divider/>)}
                    <List className={classes.fullWidth}>
                        {invoice.person && renderDetailsRow(i18n.get('invoice.contact'), invoice.person.first_name + ' ' + invoice.person.last_name, classes)}
                        {invoice.board && renderDetailsRow(i18n.get('invoice.contact'), invoice.board.board_name, classes)}
                        {/*{!short && renderDetailsRow(i18n.get('invoice.description'), invoice.description, classes)}*/}
                        {!short && renderDetailsRow(i18n.get('invoice.bill_date'), (
                            <FormaterDate value={invoice.invoice_date}/>
                        ), classes)}
                        {invoice.billed_items > 0 && renderDetailsRow(i18n.get('invoice.count_billed_items'), (
                            <FormattedNumber value={invoice.billed_items}/>
                        ), classes)}
                        {invoice.billed_value > 0 && renderDetailsRow(i18n.get('invoice.billed_value', {'unit': ''}), (
                            <FormattedNumber value={invoice.billed_value} style={"currency"} currency={"EUR"}/>
                        ), classes)}
                        {!short && renderDetailsRow(i18n.get('invoice.billed_period'), (
                            <div>
                                <FormaterDate value={new Date(invoice.year, invoice.period-2, 16)}/>
                                &nbsp;-&nbsp;
                                <FormaterDate value={new Date(invoice.year, invoice.period-1, 15)}/>
                            </div>
                        ), classes)}
                    </List>
                </div>
                {short && (
                    <Button
                        variant="outlined" color="primary"
                        component="a"
                        href={`/invoice/${invoice.id}`}
                    >
                        {i18n.get('invoice.full_view')}
                        <Icon>find_in_page</Icon>
                    </Button>
                )}
            </Paper>
        )
    }
}

const styles = theme => ({
    spaces: {
        padding: theme.spacing.unit * 1.5,
    },
    fullWidth: {
        width: "100%",
    },
    details: {
        display: 'flex',
        flexDirection: 'row',
        padding: 0,
        "&:last-child": {
            padding: 0,
        }
    },
    detailsLabel: {
        textAlign: "right",
    },
    detailsValue: {
        "& > *": {
            ...theme.helpers.oneLiner,
        },
    },
    inlineSpan: {
        display: 'inline',
    },
});


export default withStyles(styles)(InvoiceDetails);



// WEBPACK FOOTER //
// ./resources/assets/js/components/Invoice/Details.jsx